import { useState, useRef, useEffect } from 'react';
export const useTimer = (callback, timeout) => {
  const [timerId, setTimerId] = useState();
  const [timeLeft, setTimeLeft] = useState();
  const [timerStartTime, setTimerStartTime] = useState();
  const prevTimeot = useRef(timeout);
  const setTimer = () => {
    if (typeof timeout !== 'number') {
      return;
    }
    if (timeLeft === undefined) {
      setTimeLeft(timeout);
    }
    clearTimeout(timerId);
    setTimerStartTime(Date.now());
    setTimerId(window.setTimeout(callback, timeout));
  };
  const pauseTimer = () => {
    if (!timeout || !timerStartTime || !timeLeft) {
      return;
    }
    const timerPauseTime = Date.now();
    const timeElapsed = timerPauseTime - timerStartTime;
    setTimeLeft(timeLeft - timeElapsed);
    setTimerStartTime(undefined);
    clearTimeout(timerId);
  };
  useEffect(() => {
    if (prevTimeot.current !== timeout && timerId) {
      prevTimeot.current = timeout;
      clearTimeout(timerId);
      setTimer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeout]);
  useEffect(() => {
    return () => {
      clearTimeout(timerId);
    };
  }, [timerId]);
  return {
    setTimer,
    pauseTimer
  };
};